<script lang="ts">
  import PlanSelect from '$lib/components/paywall/PlanSelect.svelte';
  import AccountCreation from '$lib/components/paywall/AccountCreation.svelte';
  import Billing from '$lib/components/paywall/Billing.svelte';
  import PromoCode from '$lib/components/paywall/PromoCode.svelte';

  export let data;
  export let form;

  let price;
  let coupon;
  let country: string | undefined;
</script>

<div class="md:flex flex-row items-start md:h-[calc(100vh-179px)]">
  <div
    class={`relative flex flex-1 h-full min-h-[12.5rem] md:overflow-visible md:block ${
      !data?.pageData.showImageOnMobile ? 'hidden' : ''
    }`}
  >
    <picture>
      <source media="(min-width: 640px)" srcset="{data?.pageData.image?.url}?w=1800&q=85&fm=webp" />
      <source
        srcset="{data?.pageData.mobileImage?.url
          ? data?.pageData.mobileImage?.url
          : data?.pageData.image?.url}?w=1000&q=85&fm=webp"
      />
      <img
        src="{data?.pageData.image?.url}?fm=webp"
        alt={data?.pageData.image?.title}
        class="absolute -z-10 w-full h-full object-cover content-center"
      />
    </picture>

    <div
      class="flex items-center justify-center py-20 px-5 h-full text-center max-w-[488px] mx-auto"
    >
      <div>
        {#if data?.pageData.partnerLogoImage}
          <img
            src="{data?.pageData.partnerLogoImage?.url}?w=90&h=90&fit=fill&fm=webp"
            alt={data?.pageData.partnerLogoImage?.title}
            class="rounded-lg mx-auto mb-6"
          />
        {/if}
        {#if data?.pageData.imageText}
          <h1
            class="text-display-md md:text-display-xl font-bold text-white drop-shadow-[1px_1px_0_rgba(0,0,0,0.4)]"
          >
            {data?.pageData.imageText}
          </h1>
        {/if}
        {#if data?.pageData.imageSubText}
          <p
            class="text-display-2xs md:text-display-md font-medium text-white mt-0 drop-shadow-[1px_1px_0_rgba(0,0,0,0.4)]"
          >
            {data?.pageData.imageSubText}
          </p>
        {/if}
      </div>
    </div>
  </div>

  <div class="h-full flex-1 p-8 overflow-auto" data-testid="join-page">
    <div class="w-full mx-auto max-w-800 flex flex-col gap-10">
      <!-- Choosing a plan -->
      <PlanSelect bind:price {data} {country} />

      <!-- Promo code -->
      {#if data?.pageData.allowCouponCode}
        <PromoCode bind:coupon {price} appliedCouponCode={data?.pageData?.appliedCouponCode} />
      {/if}

      <!-- Account login / signup -->
      <AccountCreation {form} {country} />

      <!-- Billing -->
      <Billing {data} {price} {coupon} bind:country />
    </div>
  </div>
</div>
